import { useState, useEffect } from 'react'
import { X, Calendar, Compass } from 'lucide-react'

export default function WelcomeModal() {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    // Check if user has seen welcome modal
    const hasSeenWelcome = localStorage.getItem('ith_welcome_seen')
    if (!hasSeenWelcome) {
      setIsOpen(true)
    }
  }, [])

  const handleClose = () => {
    localStorage.setItem('ith_welcome_seen', 'true')
    setIsOpen(false)
  }

  const handleSchedule = () => {
    localStorage.setItem('ith_welcome_seen', 'true')
    setIsOpen(false)
    window.open('https://calendly.com/realestateos/inside-this-home-onboarding', '_blank')
  }

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6 relative">
        <button 
          onClick={handleClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
        >
          <X size={20} />
        </button>

        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-3xl">🏠</span>
          </div>
          <h2 className="text-2xl font-bold text-gray-900">Welcome to InsideThisHome!</h2>
          <p className="text-gray-600 mt-2">
            Your QR code-powered listing pages are ready. What would you like to do first?
          </p>
        </div>

        <div className="space-y-3">
          <button
            onClick={handleSchedule}
            className="w-full flex items-center gap-3 p-4 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors"
          >
            <Calendar size={20} />
            <div className="text-left">
              <div className="font-semibold">Book an Onboarding Call</div>
              <div className="text-sm text-orange-100">15 min walkthrough with our team</div>
            </div>
          </button>

          <button
            onClick={handleClose}
            className="w-full flex items-center gap-3 p-4 border-2 border-gray-200 rounded-lg hover:border-primary hover:bg-primary/5 transition-colors"
          >
            <Compass size={20} className="text-gray-600" />
            <div className="text-left">
              <div className="font-semibold text-gray-900">Explore the Dashboard</div>
              <div className="text-sm text-gray-500">Start creating listings on your own</div>
            </div>
          </button>
        </div>

        <p className="text-center text-xs text-gray-400 mt-4">
          You can always book onboarding later from the sidebar
        </p>
      </div>
    </div>
  )
}
